import { render } from "./CmsTrailers.vue?vue&type=template&id=54ccc5a7&scoped=true"
import script from "./CmsTrailers.vue?vue&type=script&lang=js"
export * from "./CmsTrailers.vue?vue&type=script&lang=js"

import "./CmsTrailers.vue?vue&type=style&index=0&id=54ccc5a7&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ccc5a7"]])

export default __exports__